import React, {useEffect, useState} from 'react';
import './eventsList.scss';
import {EventsType} from 'models';
import {Button, InfoCard} from 'components';

import PREMIUM_IMAGE_1 from 'assets/events/premium_01.png';
import PREMIUM_IMAGE_2 from 'assets/events/premium_02.png';
import {useNavigate} from "react-router-dom";
import {useGetEvents} from "../../../../operations/queries/useGetEvents";
import {removeHtml, escapeHtml} from "util/removeHtmlFromString";
import {formatTime} from "util/formatTime";

const EventsList = () => {
    const navigate = useNavigate();

    const {data} = useGetEvents();
    const [events, setEvents] = useState<Array<EventsType>>([])

    useEffect(() => {
        if (!data) return
        let eventList: Array<EventsType> = [];
        data?.forEach((eventData: any) => {
            const eventDataAttributes = eventData.attributes
            eventList.push({
                id: eventData.id,
                date: eventDataAttributes.date?.split("T")[0],
                time: formatTime(eventDataAttributes.date?.split("T")[1].split(".")[0]),
                venue: eventDataAttributes.venue,
                address: eventDataAttributes.venue.address,
                image: process.env.REACT_APP_BASE_URL + eventDataAttributes.image?.data?.attributes?.url,
                title: escapeHtml(eventDataAttributes.title),
                description: removeHtml(eventDataAttributes.description),
                category: eventDataAttributes?.categories?.data?.map((category: any) => category.attributes.name)
            })
        })
        setEvents(eventList)

    }, [data]);
    return (
        <div className={'events-list'}>
            <div className={'events-list_wrapper max'}>
                <div className={'events-list_wrapper_top'}>
                    <div className={'events-list_wrapper_top_left'}>
                        <h1>Premium Members Exclusive Events</h1>
                        <p>Become a member and get access to all events and programs offered by the SBAJ. </p>
                        <Button text={'Get Started'} type={'primary'} onclick={() => navigate('/registration/')}/>
                    </div>
                    <div className={'events-list_wrapper_top_right'}>
                        <img src={PREMIUM_IMAGE_1} alt=""/>
                        <img src={PREMIUM_IMAGE_2} alt=""/>
                    </div>
                </div>
                <div className={'events-list_wrapper_bottom'}>
                    <div className={'events-list_wrapper_bottom_heading'}>
                        <h1>Events & Programs</h1>
                    </div>
                    <div className={'events-list_wrapper_bottom_list'}>
                        {events.map(({id, date, title, description, image, time}, index) => (
                            <InfoCard key={index.toString() + id} id={id} date={date + " @ " + time} heading={title}
                                      description={description.substring(0, 70) + " [...]"} link={'#'}
                                      image={image}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventsList;
